import React from "react";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import { FaBuilding } from "react-icons/fa";
import DetailAset from "./DeatailAset";
function DataAset({ data }) {
  return (
    <table className="w-full min-w-[600px]">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Kode/SIMKUG
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Deskripsi
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Spesifikasi
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Gedung/Ruang
          </th>

          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Kategori
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Tahun Pembelian
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Sumber Dana
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Detail
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {data.length > 0 ? (
          data.map((item, index) => (
            <motion.tr
              key={item.id || index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="hover:bg-gray-50 transition-colors duration-200"
            >
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                <div className="text-sm font-medium text-gray-900 group-hover:text-primary transition-colors">
                  {item.kode || "N/A"}
                </div>
                <div className="text-sm text-gray-500">
                  {item.kode_sim || "N/A"}
                </div>
              </td>
              <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                <div className="text-sm font-medium text-gray-900 group-hover:text-primary transition-colors">
                  {item.desc || "N/A"}
                </div>
                <div className="text-sm text-gray-500">
                  {item.merk || "N/A"}
                </div>
              </td>
              <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                {item.spec || "-"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {item.gedung || item.ruang || "-"}
              </td>

              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                  {item.kategori || "-"}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {dayjs(item.tgl).format("YYYY")}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {item.sumber_dana_nama || "-"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                <DetailAset data={data} id={item.id} />
              </td>
            </motion.tr>
          ))
        ) : (
          <tr>
            <td colSpan="10" className="px-6 py-12 text-center text-gray-500">
              <div className="flex flex-col items-center gap-2">
                <FaBuilding className="w-12 h-12 text-gray-300" />
                <p>Tidak ada data yang ditemukan</p>
                <p className="text-sm">
                  Coba ubah filter atau kata kunci pencarian
                </p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default DataAset;
